import Tr from "translations/Translations";

export const PurchasingGroupStatus = {
    PREPARING: 'PREPARING',
    DATA_COLLECTION: 'DATA_COLLECTION',
    REALIZATION: "REALIZATION",
    FINISHED: "FINISHED",
    CANCELED: "CANCELED"
}
const _TR_PREFIX = 'purchasing_group_status_';

export const PurchasingGroupStatusLabel = (status) => (Tr(_TR_PREFIX + status.toLowerCase()));